(function () {
  const instances = new WeakMap();

  function initSlider(splideEl) {
    if (!splideEl || typeof Splide === 'undefined') return;
    if (instances.has(splideEl)) return;

    const slideCount = splideEl.querySelectorAll('.splide__slide').length;
    if (slideCount <= 1) return;

    const splide = new Splide(splideEl, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      pagination: false,
      arrows: false,
      speed: 400,
      drag: true,
    });

    const counter = splideEl.querySelector('[data-content-slider-counter]');
    const prevBtn = splideEl.querySelector('[data-content-slider-prev]');
    const nextBtn = splideEl.querySelector('[data-content-slider-next]');

    splide.on('mounted move', () => {
      if (!counter) return;
      counter.textContent = (splide.index + 1) + '/' + splide.length;
    });

    if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
    if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));

    splide.mount();
    instances.set(splideEl, splide);
  }

  function destroySlider(splideEl) {
    if (!splideEl) return;
    const splide = instances.get(splideEl);
    if (splide) {
      splide.destroy();
      instances.delete(splideEl);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-content-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-content-slider]').forEach(destroySlider);
  });
})();
